var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"max-height":"-moz-available"}},[_c('chat-box',{staticClass:"relative w-full",attrs:{"talent-id":_vm.talent.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }